'use client';

import { c as _c } from "react/compiler-runtime";
import { BlockList, BlockListItem } from '@udemy-v2/react-core-components';
import { Icon } from '@udemy-v2/icons';
import { Duration, useI18n } from '@udemy-v2/i18n';
import { AccordionPanel, AccordionPanelControlled } from '@udemy-v2/react-reveal-components';
import classNames from 'classnames';
import { useState } from 'react';
import styles from './curriculum-section.module.scss';
import { CurriculumLecture, Lecture } from './lecture.react-component';
import { CourseSection } from '@udemy-v2/browse-course';
import { curriculumItemIcon } from './curriculumItemIcon';
import { useClpCourse } from '@/features/course-landing-page/context/clp-course-provider.react-component';
interface SectionProps {
  arrayIndex: number;
  title: string;
  items: CourseSection['items'];
  numLectures?: number;
  contentLength?: number;
  areAllSectionsExpanded?: boolean;
  showSectionContentsText?: boolean;
}
export const CurriculumSection = t0 => {
  const $ = _c(41);
  const {
    arrayIndex,
    title,
    items,
    numLectures,
    contentLength: t1,
    areAllSectionsExpanded,
    showSectionContentsText: t2
  } = t0;
  const contentLength = t1 === undefined ? 300 : t1;
  const showSectionContentsText = t2 === undefined ? true : t2;
  const {
    ninterpolate
  } = useI18n();
  const course = useClpCourse();
  const {
    isPracticeTestCourse
  } = course;
  let t3;
  if ($[0] !== areAllSectionsExpanded) {
    t3 = {
      expanded: null,
      forValue: areAllSectionsExpanded
    };
    $[0] = areAllSectionsExpanded;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const [localState, setLocalState] = useState(t3);
  let localExpanded = localState.expanded;
  if (localState.forValue !== areAllSectionsExpanded) {
    localExpanded = null;
    setLocalState({
      expanded: null,
      forValue: areAllSectionsExpanded
    });
  }
  let t4;
  if ($[2] !== arrayIndex) {
    t4 = () => arrayIndex === 0 ? true : false;
    $[2] = arrayIndex;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const getDefaultExpanded = t4;
  const expanded = localExpanded !== null ? localExpanded : typeof areAllSectionsExpanded === "boolean" ? areAllSectionsExpanded : getDefaultExpanded();
  let t5;
  if ($[4] !== areAllSectionsExpanded) {
    t5 = isExpanded => {
      setLocalState({
        expanded: isExpanded,
        forValue: areAllSectionsExpanded
      });
    };
    $[4] = areAllSectionsExpanded;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const handleToggle = t5;
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = function renderTitle(t7) {
      const {
        children,
        className,
        ...props
      } = t7;
      return <h3 {...props} className={classNames(className, styles["section-title-container"])}>{children}</h3>;
    };
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const renderTitle = t6;
  let t7;
  if ($[7] !== contentLength || $[8] !== isPracticeTestCourse || $[9] !== ninterpolate || $[10] !== numLectures || $[11] !== showSectionContentsText || $[12] !== title) {
    t7 = function constructPanelDisplay() {
      return <><span className={styles["section-title"]}>{title}</span>{!isPracticeTestCourse && showSectionContentsText && numLectures && <span className={classNames("ud-text-sm", styles["hidden-on-mobile"], styles["section-content-stats"])} data-purpose="section-content-stats">{ninterpolate("%(numLectures)s lecture", "%(numLectures)s lectures", numLectures, {
            numLectures
          })}{contentLength && <>{" \u2022 "}<Duration numSeconds={contentLength} presentationStyle="human" /></>}</span>}</>;
    };
    $[7] = contentLength;
    $[8] = isPracticeTestCourse;
    $[9] = ninterpolate;
    $[10] = numLectures;
    $[11] = showSectionContentsText;
    $[12] = title;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const constructPanelDisplay = t7;
  if (isPracticeTestCourse) {
    let t8;
    if ($[14] !== constructPanelDisplay) {
      t8 = constructPanelDisplay();
      $[14] = constructPanelDisplay;
      $[15] = t8;
    } else {
      t8 = $[15];
    }
    const t9 = arrayIndex === 0;
    let t10;
    if ($[16] !== items || $[17] !== ninterpolate) {
      let t11;
      if ($[19] !== ninterpolate) {
        t11 = (item, index) => {
          const icon = <Icon color="neutral" glyph={curriculumItemIcon(item.type)} label={false} />;
          const questionsCount = "questionsCount" in item ? item.questionsCount : undefined;
          return <BlockListItem key={item.id + index} icon={icon} className={styles["section-content"]}><div className={styles.row}><span className={styles["course-lecture-title"]} data-purpose="practice-test-title">{item.title}</span>{questionsCount ? <span className={styles["practice-test-questions-count"]} data-purpose="practice-test-questions-count">{ninterpolate("%(count)s question", "%(count)s questions", questionsCount, {
                  count: questionsCount
                })}</span> : null}</div></BlockListItem>;
        };
        $[19] = ninterpolate;
        $[20] = t11;
      } else {
        t11 = $[20];
      }
      t10 = items.map(t11);
      $[16] = items;
      $[17] = ninterpolate;
      $[18] = t10;
    } else {
      t10 = $[18];
    }
    let t11;
    if ($[21] !== t10) {
      t11 = <BlockList iconAlignment="left" size="small">{t10}</BlockList>;
      $[21] = t10;
      $[22] = t11;
    } else {
      t11 = $[22];
    }
    let t12;
    if ($[23] !== t11 || $[24] !== t8 || $[25] !== t9) {
      t12 = <AccordionPanel title={t8} defaultExpanded={t9} className={styles.panel}>{t11}</AccordionPanel>;
      $[23] = t11;
      $[24] = t8;
      $[25] = t9;
      $[26] = t12;
    } else {
      t12 = $[26];
    }
    return t12;
  }
  let t8;
  if ($[27] !== constructPanelDisplay) {
    t8 = constructPanelDisplay();
    $[27] = constructPanelDisplay;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  let t9;
  if ($[29] !== items || $[30] !== showSectionContentsText) {
    let t10;
    if ($[32] !== showSectionContentsText) {
      t10 = (item_0, index_0) => <Lecture key={index_0} lecture={item_0 as CurriculumLecture} showSectionContentsText={showSectionContentsText} />;
      $[32] = showSectionContentsText;
      $[33] = t10;
    } else {
      t10 = $[33];
    }
    t9 = items.map(t10);
    $[29] = items;
    $[30] = showSectionContentsText;
    $[31] = t9;
  } else {
    t9 = $[31];
  }
  let t10;
  if ($[34] !== t9) {
    t10 = <BlockList iconAlignment="left" size="small">{t9}</BlockList>;
    $[34] = t9;
    $[35] = t10;
  } else {
    t10 = $[35];
  }
  let t11;
  if ($[36] !== expanded || $[37] !== handleToggle || $[38] !== t10 || $[39] !== t8) {
    t11 = <AccordionPanelControlled title={t8} renderTitle={renderTitle} className={styles.panel} expanded={expanded} onToggle={handleToggle}>{t10}</AccordionPanelControlled>;
    $[36] = expanded;
    $[37] = handleToggle;
    $[38] = t10;
    $[39] = t8;
    $[40] = t11;
  } else {
    t11 = $[40];
  }
  return t11;
};